import { motion, useScroll, useSpring } from "framer-motion";

// Thin gallery-walk-through scroll-progress line at the very top.
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      data-testid="scroll-progress"
      aria-hidden="true"
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 z-[70] h-[2px] origin-left bg-gradient-to-r from-[#D4A373] via-[#E6CCB2] to-[#D4A373]"
    />
  );
}
